/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import React from 'react';
import './Header.css';
import logo from '../../../public/images/RTX_Logo.png'
import { useNavigate } from 'react-router-dom';
const Header: React.FC = () => {

  const navigate = useNavigate()



  return <header>
    <div className="logo">
      <img src={logo} alt="Logo" className="logo-banner" onClick={() => navigate('/')} />
    </div>
  </header>;
};

export default Header;
